import { render, staticRenderFns } from "./BaseInputTel.vue?vue&type=template&id=4751abf4&scoped=true"
import script from "./BaseInputTel.vue?vue&type=script&lang=js"
export * from "./BaseInputTel.vue?vue&type=script&lang=js"
import style0 from "./BaseInputTel.vue?vue&type=style&index=0&id=4751abf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4751abf4",
  null
  
)

export default component.exports